export default [
    {
        name: 'Despesas',
        url: '/despesasgerais/finalizacao/despesas',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'FINALIZAÇÃO'
        },
        regras: 'DESP-GERAIS-FINAL-00'
    },
    {
        name: 'Pagamentos',
        url: '/despesasgerais/finalizacao/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'FINALIZAÇÃO'
        },
        regras: 'DESP-GERAIS-FINAL-PAG-00'
    },
]